import './questionary.css';
import { useState } from "react";

const QuestionaryStepForm = () => {
    const [step, setStep] = useState(1);

    const [formData, setFormData] = useState({
        secondName: '',
        firstName: '',
        middleName: '',
        birthday: '',
        email: '',
        about: '',
        mainEducation: '',
        secondEducation: '',
        organizationAndPosition: '',
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            const response = await fetch('https://meetmind.ru/v1/spec/questionary/fill', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({"questionary":{
                    "email": formData.email,
                    "birthday": formData.birthday,
                    "first_name": formData.firstName,
                    "second_name": formData.secondName,
                    "middle_name": formData.middleName,
                    "info": formData.about,
                    "main_education": formData.mainEducation,
                    "second_education": formData.secondEducation,
                    "organization_and_position": formData.organizationAndPosition,
                }}),
            });

            if (response.ok) {
                window.location.href = "/profile";
            } else {
                console.error('Ошибка при отправке данных');
            }
        } catch (error) {
            console.error('Произошла ошибка:', error);
        }
    };

    const nextStep = () => {
        setStep(step + 1);
    };

    const prevStep = () => {
        setStep(step - 1);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const renderForm = () => {
        switch (step) {
            case 1:
                return (
                    <div className="questionary">
                        <h1 className="questionary__title">
                            Давайте сотрудничать!
                        </h1>
                        <p className="questionary__paragraph">
                            Пожалуйста, заполните анкету.
                        </p>
                        <p className="questionary__paragraph">
                            Она поможет нам составить Ваш профессиональный портрет.
                        </p>
                        <div className="questionary__icon">
                            <i className="fa-solid fa-chevron-down"></i>
                        </div>
                        <div className="questionary__block">
                            <h2 className="questionary__subtitle">
                                Контактная информация
                            </h2>
                            <div className="questionary__field">
                                <label className="questionary__label label">
                                    Фамилия *
                                    <input
                                        className="questionary__input input"
                                        type="text"
                                        name="secondName"
                                        value={formData.secondName}
                                        onChange={handleInputChange}
                                        placeholder="Иванов"
                                    />
                                </label>
                            </div>
                            <div className="questionary__field">
                                <label className="questionary__label label">
                                    Имя *
                                    <input
                                        className="questionary__input input"
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleInputChange}
                                        placeholder="Иван"
                                    />
                                </label>
                            </div>
                            <div className="questionary__field">
                                <label className="questionary__label label">
                                    Отчество
                                    <input
                                        className="questionary__input input"
                                        type="text"
                                        name="middleName"
                                        value={formData.middleName}
                                        onChange={handleInputChange}
                                        placeholder="Иванович"
                                    />
                                </label>
                            </div>
                            <div className="questionary__field">
                                <label className="questionary__label label">
                                    Дата рождения *
                                    <input
                                        className="questionary__input input"
                                        type="date"
                                        name="birthday"
                                        value={formData.birthday}
                                        onChange={handleInputChange}
                                    />
                                </label>
                            </div>
                            <div className="questionary__field">
                                <label className="questionary__label label">
                                    Адрес электронной почты
                                    <input
                                        className="questionary__input input"
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder="example@meetmind.ru"
                                    />
                                </label>
                            </div>
                        </div>
                        <div className="questionary__stepper stepper">
                            <div className="stepper__row">
                                <button className="stepper__button button" type="button" disabled>Назад</button>
                                <div className="stepper__step">1/3</div>
                                <button className="stepper__button button" type="button" onClick={nextStep}>Далее</button>
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="questionary">
                        <div className="questionary__block">
                            <h2 className="questionary__subtitle">
                                Образование
                            </h2>
                            <div className="questionary__field">
                                <label className="questionary__label label">
                                    Основное образование
                                    <span>Напишите о базовом психологическом (смежном) обучении или переподготовке. Год окончания, Название ВУЗа, Название факультета и специальности, Академическая степень (бакалавриат, магистратура) или учёная степень (при наличии)</span>
                                    <textarea
                                        className="questionary__textarea textarea"
                                        rows="5"
                                        name="mainEducation"
                                        value={formData.mainEducation}
                                        onChange={handleInputChange}
                                    ></textarea>
                                </label>
                            </div>
                            <div className="questionary__field">
                                <label className="questionary__label label">
                                    Дополнительное образование
                                    <span>Программы повышения квалификации, семинары, курсы. Укажите названия и годы прохождения.</span>
                                    <textarea
                                        className="questionary__textarea textarea"
                                        rows="5"
                                        name="secondEducation"
                                        value={formData.secondEducation}
                                        onChange={handleInputChange}
                                    ></textarea>
                                </label>
                            </div>
                        </div>
                        <div className="questionary__stepper stepper">
                            <div className="stepper__row">
                                <button className="stepper__button button" type="button" onClick={prevStep}>Назад</button>
                                <div className="stepper__step">2/3</div>
                                <button className="stepper__button button" type="button" onClick={nextStep}>Далее</button>
                            </div>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="questionary">
                        <div className="questionary__block">
                            <h2 className="questionary__subtitle">
                                О себе
                            </h2>
                            <div className="questionary__field">
                                <label className="questionary__label label">
                                    Расскажите об организациях, в которых Вы состоите, и Ваш статус
                                    <textarea
                                        className="questionary__textarea textarea"
                                        rows="5"
                                        name="organizationAndPosition"
                                        value={formData.organizationAndPosition}
                                        onChange={handleInputChange}
                                    ></textarea>
                                </label>
                            </div>
                            <div className="questionary__field">
                                <label className="questionary__label label">
                                    Расскажите о себе в свободной форме, что Вы считаете нужным чтобы понять, какой Вы специалист
                                    <textarea
                                        className="questionary__textarea textarea"
                                        rows="5"
                                        name="about"
                                        value={formData.about}
                                        onChange={handleInputChange}
                                    ></textarea>
                                </label>
                            </div>
                            <div className="questionary__actions">
                                <button type="submit" className="stepper__button button">Отправить анкету и завершить регистрацию</button>
                            </div>
                        </div>
                        <div className="questionary__stepper stepper">
                            <div className="stepper__row">
                                <button className="stepper__button button" type="button" onClick={prevStep}>Назад</button>
                                <div className="stepper__step">3/3</div>
                                <button className="stepper__button button" type="button" disabled>Далее</button>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            {renderForm()}
        </form>
    )
}

export default QuestionaryStepForm;
